import React, { Fragment } from "react";
import { useTranslation } from "../../hooks/useTranslation";
import { createUseStyles } from "react-jss";
import { classNames } from "../../utils/classNames";
import { SCREEN_READER_ONLY } from "../../theming/helpers";
export const RowChevron = ({ disabled, }) => {
    const classes = useRowChevronClasses();
    const t = useTranslation();
    return (React.createElement(Fragment, null,
        React.createElement("span", { className: classes.srOnly }, disabled ? t("Action disabled") : t("Open option")),
        React.createElement("span", { className: classNames("glyphicon glyphicon-chevron-right", disabled ? classes.actionDisabled : "", classes.icon) })));
};
const useRowChevronClasses = () => {
    const useStyles = createUseStyles({
        icon: {
            paddingTop: 4,
        },
        actionDisabled: {
            opacity: 0.3,
        },
        srOnly: SCREEN_READER_ONLY,
    });
    return useStyles();
};
